import React from "react";

function MainArea(props) {
  return (
    <div className="form">
      <div className="container">{props.children}</div>
    </div>
  );
}

export default MainArea;
